import type { AtTag } from "shared/util/tag";
import type { AbsolutePath } from "shelving";
import { getURL } from "shelving";
import { CLAIM_CHALLENGE, RESET_CHALLENGE, START_CHALLENGE } from "shared/api";
import { Button, CopyButton, ModalButton, PathButton } from "shared/react";
import { type ContentEntity, isChallengeDone } from "shared/schema";
import { CreatorCondition } from "../create/CreatorCondition.js";
import { AssignChallengePicker } from "../group/AssignChallengePicker.js";
import { ListAddPicker } from "../list/ListAddPicker.js";
import { ListRemovePicker } from "../list/ListRemovePicker.js";
import { getCallAPIWithNotice } from "../util/api.js";
import { useAttemptItem, useCreatorItem } from "../util/data.js";
import { useItem } from "../util/db.js";

export function ChallengeMenu({ id }: { id: string }): React.ReactElement | null {
	const challenge = useItem("challenge", id);
	const attempt = useAttemptItem(id);
	const { creator, tasks, slug } = challenge.data;
	const username = useCreatorItem(creator).value?.username;
	const entity: ContentEntity | AtTag = username ? `@${username}/${slug}` : `challenge:${id}`;
	const path: AbsolutePath = username ? `/${username}/${slug}` : `/challenge/${id}`;
	return (
		<>
			<nav className="flex-column gap-hairline">
				<h2 className="label">Challenge</h2>
				{!attempt.value ? (
					<Button onClick={getCallAPIWithNotice(START_CHALLENGE, id)}>Start challenge</Button>
				) : (
					<>
						{isChallengeDone(tasks, attempt.value.totals) ? <Button onClick={getCallAPIWithNotice(CLAIM_CHALLENGE, id)}>Claim challenge</Button> : null}
						<Button onClick={getCallAPIWithNotice(RESET_CHALLENGE, id)}>Reset progress</Button>
					</>
				)}
				<ModalButton modal={<AssignChallengePicker cid={id} />}>Assign to group</ModalButton>
				<Button>Duplicate challenge</Button>
				<CreatorCondition creator={creator}>
					<PathButton path={`/challenge/${id}/edit`}>Edit challenge</PathButton>
				</CreatorCondition>
			</nav>
			<nav className="flex-column gap-hairline">
				<h2 className="label">Lists</h2>
				<ModalButton modal={<ListAddPicker item={`challenge:${id}`} />}>Add to list</ModalButton>
				<ModalButton modal={<ListRemovePicker item={`challenge:${id}`} />}>Remove from list</ModalButton>
			</nav>
			<nav className="flex-row flex-stretch gap-hairline">
				<CopyButton copy={entity}>Copy tag</CopyButton>
				<CopyButton copy={getURL(path).href}>Copy link</CopyButton>
			</nav>
		</>
	);
}
